module.exports = __webpack_public_path__ + "img/hakuna_bg05.33c6c9de.png";